import {API_URLS} from '@/const';
import {http} from '@/helper';

export const accountApi = {
  getTasksList() {
    return http.get(API_URLS.TASKS_LIST, {});
  },
  getPreCheck() {
    return http.get(API_URLS.WALLETS_APP_PRE_CHECK, {});
  },
  updateProfile(params) {
    return http.post(API_URLS.UPDATE_PROFILE, {
      params,
      formatter(data) {
        data.isMain = data.parentId === 0;
        data.isSub = !data.isMain;
        return data;
      },
    });
  },
  changePassword(query, params) {
    return http.post(API_URLS.USER_CHANGE_PASSWORD, {query, params});
  },
  getFeeRate(query) {
    return http.get(API_URLS.FEE_RATE_CONTRACT, {query});
  },
  getOtp(query) {
    return http.get(API_URLS.USER_OTP, {query});
  },
  otpBind(query) {
    return http.post(API_URLS.OTP_BIND, {query});
  },
  otpConfirmbind(query) {
    return http.post(API_URLS.OTP_CONFIRMBIND, {query});
  },
  otpConfirmunbind(query) {
    return http.post(API_URLS.OTP_CONFIRMUNBIND, {query});
  },
  otpUnbind(query) {
    return http.post(API_URLS.OTP_UNBIND, {query});
  },
  getSwitchAccount() {
    return http.get(API_URLS.SWITCH_ACCOUNT, {
      formatter(data) {
        data.rows.forEach((o) => (o.isSub = o.parentId !== 0));
        return data;
      },
    });
  },
  getUserChildren(query) {
    return http.get(API_URLS.USER_CHILDREN, {query});
  },
  getUserChildrenV2(query) {
    return http.get(API_URLS.USER_CHILDREN_V2, {query});
  },
  getUserChildrenUta(query) {
    return http.get(API_URLS.USER_CHILDREN_UTA, {query});
  },
  postUserChildren(params) {
    return http.post(API_URLS.USER_CHILDREN, {params});
  },
  //changeChildren
  putUserChildren(query) {
    return http.put(API_URLS.USER_CHILDREN, {query});
  },
  putUserSwitch(query) {
    return http.put(API_URLS.USER_SWITCH, {query});
  },
  getChildrenAssets(query) {
    return http.get(API_URLS.CHILDREN_ASSETS, {query});
  },
  getChildrenAssetsV2(query) {
    return http.get(API_URLS.CHILDREN_ASSETS_V2, {query});
  },
  getChildrenAssetsUta(query) {
    return http.get(API_URLS.CHILDREN_ASSETS_UTA, {query});
  },
  putUserSwitchBack(query) {
    return http.put(API_URLS.USER_SWITCHBACK, {query});
  },
  getCountryList(query) {
    return http.get(API_URLS.REFERRALS_COUNTRY, {query});
  },
  getDisableLangList() {
    return http.get(API_URLS.PRIVACY_LANG, {});
  },
  getRankList(query) {
    return http.get(API_URLS.RANK_LIST, {query});
  },
  getRankListAugust(query) {
    return http.get(API_URLS.RANK_LIST_AUGUST, {query});
  },
  switchToSubAccount(clientCnt) {
    return http.put(API_URLS.SUB_ACCOUNT_SWITCH, {query: {clientCnt}});
  },
  switchToMasterAccount() {
    return http.put(API_URLS.MASTER_ACCOUNT_SWITCHBACK, {});
  },
  joinAgent(params) {
    return http.post(API_URLS.REFERRALS, {params});
  },
  getApplyInfo(query) {
    return http.get(API_URLS.AGENT_APPLY_INFO, {query});
  },
  //Premium
  getBaseMembershipInfo() {
    return http.get(API_URLS.BASE_MEMBERSHIP_INFO, {});
  },
  updateAutoRenewConfig(query) {
    return http.post(API_URLS.UPDATE_AUTORENEW_CONFIG, {query});
  },
  // Key
  getKeysList(query) {
    return http.get(API_URLS.KEYS_LIST, {query});
  },
  getUserBd() {
    return http.get(API_URLS.VIP_MANAGER_EMAIL, {query: {}});
  },
  getKeysDetail(query) {
    return http.get(API_URLS.KEYS_DETAIL, {query});
  },
  postKeysUpdate(query, params) {
    return http.post(API_URLS.KEYS_UPDATE, {query, params});
  },
  postKeysCreate(query, params) {
    return http.post(API_URLS.KEYS_CREATE, {query, params});
  },
  postKeysDelete(query) {
    return http.post(API_URLS.KEYS_DELETE, {query});
  },
  postKeysRefresh(query) {
    return http.post(API_URLS.KEYS_REFRESH, {query});
  },
  shareKeyToSubAccounts(id, subAccountIds, {mailCode, otpCode}) {
    return http.post(API_URLS.KEYS_SYNC_TO_SUB_ACCOUNTS, {
      params: {
        id: id,
        syncToList: subAccountIds,
        syncType: subAccountIds.length === 0 ? 2 : 1,
      },
      query: {mailCode, otpCode},
    });
  },
  // Recommend-phemex
  personalRecommendInfo(query) {
    return http.get(API_URLS.PERSONAL_RECOMMEND_INFO, {query});
  },
  recommendRecordList(query) {
    return http.get(API_URLS.RECOMMEND_RECORD_LIST, {query});
  },
  //transfer
  walletsTransferOut(params) {
    return http.post(API_URLS.TRANSFER_OUT, {params});
  },
  walletsTransferin(params) {
    return http.post(API_URLS.WALLETS_TRANSFERIN, {params});
  },
  spotMainAccountToSubAccount(params) {
    return http.post(API_URLS.SPOT_MAIN_ACCOUNT_TO_SUB_ACCOUNT, {params});
  },
  spotSubAccountToSubAccount(params) {
    return http.post(API_URLS.SPOT_SUB_ACCOUNT_TO_SUB_ACCOUNT, {params});
  },
  spotSubAcountToMainAccount(params) {
    return http.post(API_URLS.SPOT_SUB_ACCOUNT_TO_MAIN_ACCOUNT_, {params});
  },
  contractMainAccountToSubAccount(params) {
    return http.post(API_URLS.CONTRACT_MAIN_ACCOUNT_TO_SUB_ACCOUNT, {params});
  },
  contractSubAccountToSubAccount(params) {
    return http.post(API_URLS.CONTRACT_SUB_ACCOUNT_TO_SUB_ACCOUNT, {params});
  },
  contractSubAcountToMainAccount(params) {
    return http.post(API_URLS.CONTRACT_SUB_ACCOUNT_TO_MAIN_ACCOUNT, {params});
  },
  childrenEmail(query) {
    return http.put(API_URLS.CHILDREN_EMAIL, {query});
  },
  generalTickling(params) {
    return http.post(API_URLS.GENERAL_TICKLING, {params});
  },
  getGeneralTickling(query) {
    return http.get(API_URLS.GENERAL_TICKLING, {query});
  },
  uploadImage(formData) {
    return http.upload(API_URLS.UPLOAD_IMAGE, {formData});
  },
  getUsersAntiPhishingCode(query) {
    return http.get(API_URLS.USERS_ANTI_PHISHING_CODE, {query});
  },
  genUsersAntiPhishingCodeSubmit(query, params) {
    return http.post(API_URLS.USERS_ANTI_PHISHING_CODE_SUBMIT, {query, params});
  },
  getTradingFeeRate(query) {
    return http.get(API_URLS.SPOT_WALLET_ASSETS_TRADING_FEE_RATE, {query});
  },
  getUserGrowthInfo(query, params) {
    return http.get(API_URLS.USER_GROWTH_INFO, {query, params});
  },
  getgrowthConfigs(query, params) {
    return http.get(API_URLS.GROWTH_CONFIG, {query, params});
  },
  getUserLevelNotifications(query, params) {
    return http.get(API_URLS.USER_LEVEL_NOTIFICATIONS, {query, params});
  },
  getAchievements(query, params) {
    return http.get(API_URLS.USER_ACHIEVEMENTS, {query, params});
  },
  getGrowthHistories(query, params) {
    return http.get(API_URLS.USER_GROWTH_HISTORIES, {query, params});
  },
  getQualifications(query, params) {
    return http.get(API_URLS.PREMIUM_QUALIFICATION_LIST, {query, params});
  },
  getGrowthTasks(query, params) {
    return http.get(API_URLS.GROWTH_TASKS, {query, params});
  },
  confirmLevelNotifcation(params) {
    return http.post(API_URLS.USER_LEVEL_NOTIFICATIONS_CONFIRM, {params});
  },
  getOfficialVerify(query) {
    return http.get(API_URLS.OFFICIAL_VERIFY, {query});
  },
  genStart2fa(params) {
    return http.post(API_URLS.ACCOUNT_GENERAL_START, {params});
  },
  getSoulPassSummary() {
    return http.get(API_URLS.XPT_SOUL_PASS_SUMMARY, {query: {}});
  },
  getXPTLevelConfig(ref) {
    return http.get(API_URLS.XPT_LEVEL_CONFIG, {query: {ref}});
  },
  getUserXPTLevelInfo(ref) {
    return http.get(API_URLS.XPT_USER_LEVEL_CONFIG, {query: {ref}});
  },
  queryUseAssets(scopeType) {
    return http.get(API_URLS.USER_ASSETS_QUERY, {query: {scopeType, currency: 'USDT'}});
  },
  postWeb3Start(params) {
    return http.post(API_URLS.WEB3_GENERAL_START, {params});
  },
  postAccountTransferMainSub(params) {
    return http.post(API_URLS.ACCOUNT_TRANSFER_MAIN_SUB, {params});
  },
  queryPasskeyAccount() {
    return http.get(API_URLS.PASSKEY_LIST, {});
  },
  verifyPasskey(params) {
    return http.post(API_URLS.PASSKEY_ENABLE, {params});
  },
  withdrawStartWithPasskey(params) {
    return http.post(API_URLS.PASSKEY_WITHDRAW_START, {params});
  },
  startRegisterPasskey(params) {
    return http.post(API_URLS.PASSKEY_REGISTER, {params});
  },
  finishedRegisterPasskey(params) {
    return http.post(API_URLS.PASSKEY_FINISHED, {params});
  },
  removePasskey(params) {
    return http.post(API_URLS.PASSKEY_REMOVE, {params});
  },
  renamePasskey(params) {
    return http.post(API_URLS.PASSKEY_RENAME, {params});
  },
};
